// ===========================================================================
// APERTURA DELLA LIVECHAT ON CLICK
// ===========================================================================
$('.open-chat').on('click', function () {
  $zopim(function () {
    $zopim.livechat.window.show();
  });
});
